import React from "react";
import {Cell, Label, Pie, PieChart} from "recharts";
import {h2FontSize, theme} from "../../theme";

type UserPercentageGraphProps = {
  count: number;
  total: number;
  title: string;
}
export const UserPercentageGraph = ({count, total, title}: UserPercentageGraphProps) => {
  return (
    <PieChart
      width={190}
      height={190}
      style={{
        margin: "auto",
        textAlign: "center"
      }}
    >
      <Pie
        dataKey="value"
        data={[{name: title, value: count}, {name: 'Total', value: total - count}]}
        cx="50%"
        cy="50%"
        innerRadius={50}
        outerRadius={95}
      >
        <Cell fill={theme.more.riskyRed}/>
        <Cell fill={theme.more.andyGreen}/>

        <Label
          position="center"
          content={
            // @ts-ignore
            <InnerChartLabel count={count} total={total}/>
          }
        />
      </Pie>
    </PieChart>
  );

}

const InnerChartLabel = ({
  viewBox,
  count,
  total,
}: {
  viewBox: any;
  count: number;
  total: number;
}) => {
  // Center the labels.
  const percent = Math.round(count / total * 100);
  // recharts v3 passes a cartesian viewBox {x, y, width, height} to a Pie
  // Label's custom content (v2 gave polar {cx, cy}); derive the centre from it,
  // falling back to polar fields if a future version provides them.
  const {x = 0, y = 0, width = 0, height = 0, cx: polarCx, cy: polarCy} = viewBox ?? {};
  const cx = polarCx ?? x + width / 2;
  const cy = polarCy ?? y + height / 2;
  const singleDigitXOffset = 22;
  let numberLeftShift = singleDigitXOffset;
  if (percent > 99)
    numberLeftShift = singleDigitXOffset + 23;
  else if (percent > 10)
    numberLeftShift = singleDigitXOffset + 13;

  return (
    <React.Fragment>
      <text x={cx - numberLeftShift} y={cy + 7}>
        <tspan
          style={{
            textAlign: 'right',
            fontWeight: 'normal',
            fontSize: h2FontSize,
          }}
        >
          {`${percent}%`}
        </tspan>
      </text>
      <text x={cx - 21} y={cy + 20}>
        <tspan
          style={{
            fontSize: "0.6em",
          }}
        >
          {count} / {total}
        </tspan>
      </text>
    </React.Fragment>
  );
};